import type { DeepPartial } from '@luna/utils-ts';

import type { Orders } from '../../types/Orders';

export const ordersCZFeatureConfig: DeepPartial<Orders> = {
    historyUrlPath: 'netbanking/cz/my/securities/<%=securityId%>/orders/<%=orderId%>/history',
    showDetailAtBest: true,
    showFeesPriceNote: true,
    showOpenOrders: true,
    showPortfolioDropdown: true,
    stickyHeaderMobile: true,
    typesNotToShowSellValidFromDate: ['PREMIUM_DEPOSIT'],
};
